import { MouseEvent, FunctionComponent, ReactElement } from 'react';
import { TablePagination } from '@mui/material';

interface PaginationProps {
	currentPage: number;
	perPage: number;
	totalItems: number;
	onPageChange: (
		page: number,
		event?: MouseEvent<HTMLButtonElement, globalThis.MouseEvent> | null
	) => void;
	hideOnPrint?: boolean;
}

const Pagination: FunctionComponent<PaginationProps> = ({
	currentPage,
	perPage,
	totalItems,
	onPageChange,
	hideOnPrint = false,
}): ReactElement => (
	<TablePagination
		sx={{ displayPrint: hideOnPrint ? 'none' : 'block' }}
		component="div"
		rowsPerPageOptions={[perPage]}
		count={totalItems}
		rowsPerPage={perPage}
		page={currentPage - 1}
		onPageChange={(event, page) => onPageChange(page + 1, event)}
	/>
);

export default Pagination;
